<img src="{{blocked ? '/assets/images/decline-sign-blocked.svg' : '/assets/images/decline-sign-unblocked.svg'}}" (click)="blockButtonClicked()"
     alt="{{blocked ? 'Unblock this item' : 'Block this item'}}" tabindex="0" role="button" [ngClass]="{'disabled': !enabled}">
